import { type ImageLoader } from 'next/image'

export const storyblokImageLoader: ImageLoader = ({ quality, src, width }) => {
  let url = `${src}/m/${width}x0`
  if (quality) {
    url += `/filters:quality(${quality})`
  }

  return url
}
